import './App.css';
import Home from './components/Home';
import 'bootstrap/dist/css/bootstrap.min.css';  
import './assets/css/main.css';
import { Route, Routes } from 'react-router-dom';
import HeaderMain from './components/HeaderMain';
import AboutView from './components/AboutView';
import ContactView from './components/ContactView';
import FooterView from './components/FooterView';
import FormApplication from './components/ApplicationForm/FormApplication';
//import Materials from './components/ArchiveMaterial/Materials';
import TablesMaterials from './components/ArchiveMaterial/TablesMaterials';
import TablesResearch from './components/ArchiveMaterial/TablesResearch';
import SearchPage from './components/Archives/SearchPage';
import SearchPage1 from './components/Archives/SearchPage1';
import GalleryView from './components/Gallery/GalleryView';
import ApplicationForm from './components/ApplicationForm/ApplicationForm';
import GalleryMain from './components/NewGallery/GalleryMain';
import FlashNews from './components/flashnews/FlashNews';
import JubileeMain from './components/PlatinumJubilee/JubileeMain';


function App() {
  return (
    <div className="App">
      <HeaderMain />
      <div style={{marginTop:"75px"}}>
        <FlashNews />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutView />} />
        <Route path="/contact" element={<ContactView />} />
        <Route path="/services" element={<Home />} />
        <Route path="/research" element={<TablesResearch />} /> 
        <Route path="/materials" element={<TablesMaterials />} />
        <Route path="/application" element={<ApplicationForm />} />
        <Route path="/search" element={<SearchPage1 />} />
        <Route path="/gallery" element={<GalleryMain />} />
        <Route path="/platinum-jubilee/*" element={<JubileeMain />} />
        <Route path="/platinum-jubilee" element={<JubileeMain />} />
      </Routes>
      </div>
      <FooterView />
    </div>
  );
}
export default App;
